import { render } from "./SplineChart.vue?vue&type=template&id=228e7822&scoped=true"
import script from "./SplineChart.vue?vue&type=script&lang=js"
export * from "./SplineChart.vue?vue&type=script&lang=js"

import "./SplineChart.vue?vue&type=style&index=0&id=228e7822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228e7822"]])

export default __exports__